module.exports = __webpack_public_path__ + "static/media/ad-notification-textlink-mockup-upper.bede3b30.png";